/*
 * @Description: 品牌管理
 * @Author: yy
 * @LastEditors: yangyang yyangacom@163.com
 * @Date: 2019-04-16 16:07:24
 * @LastEditTime: 2023-12-04 13:38:07
 */

import React from 'react'

// @ts-ignore
import s from './style.css'
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import classNames from 'classnames'

import qs from 'querystring'

import { 
  getBrandInfo,
   getIndustryInfo,
   updateBrandName,
   updateBrandWords,
   doChangeBrandInfo,
   getReportBrandV,
   doAddReportBrandV,
   doChangeReportBrandV,
   doDelReportBrandV,
   doChangeEmotionReportBrandV
} from '../../controller';
import Tag from '../../components/Tag/Tag';
import EditInput from './EditInput';
import TimeInput from '../../components/TimeInput/TimeInput';
import AdminBackNav from '../adminBackNav/adminBackNav';
import BrandInput from '../../components/BrandInput/BrandInput';
import BrandComponent from './components/BrandComponent';

const platformList=[
  {
    type:'all',
    class:'所有平台'
  },{
    type:'wx',
    class:'微信'
  },{
    type:'wb',
    class:'微博'
  },{
    type:'zh',
    class:'知乎'
  },{
    type:'tt',
    class:'头条'
  },{
    type:'qeh',
    class:'企鹅号'
  },{
    type:'shh',
    class:'搜狐号'
  },{
    type:'wyh',
    class:'网易号'
  },{
    type:'ydh',
    class:'一点号'
  },{
    type:'bjh',
    class:'百家号'
  },{
    type:'xlkdh',
    class:'新浪看点号'
  },{
    type:'dfh',
    class:'大风号'
  },{
    type:'xqh',
    class:'雪球号'
  },{
    type:'pph',
    class:'澎湃号'
  }
]

const platMap = (function () {
  const result = {}
  platformList.forEach(item => {
    result[item.type] = item.class
  })
  return result
})()

class BrandNew extends React.Component {
  render () {
    return (
      <div className={s.container}>
        <AdminBackNav />

        <BrandComponent />
      </div>
    )
  }
}

export default withStyles(s)(BrandNew)



// WEBPACK FOOTER //
// src/routes/cms/BrandNew.js